export default function camelToKebab(str) {
    return str.replace(/([A-Z])/g, '-$1').toLowerCase();
}
